import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { baseAnimation } from 'src/lib/animations';
import { MatNotificationData } from './mat-notifications.service';

@Component({
  selector: 'mat-notification',
  templateUrl: './mat-notification.component.html',
  styleUrls: ['./mat-notification.component.scss'],
  animations: baseAnimation
})
export class MatNotificationComponent {

	@Input() notification: MatNotificationData;
	
	_elevation: number = -1;
	@Input()
	get elevation() { return this._elevation; }
	set elevation(value: any) { this._elevation = coerceNumberProperty(value); }

	get isInline(): boolean { return (this.notification.progress === null || this.notification.progress === undefined) 
								&& !this.notification.image
								&& this.notification.actions?.length < 3
	};
	
	get shouldCenter(): boolean { return (this.notification.progress === null || this.notification.progress === undefined)
									&& !this.notification.type
									&& !this.notification.icon
									&& !this.notification.title
									&& !this.notification.actions;
	};

	@Output() onClose: EventEmitter<null> = new EventEmitter();

	constructor() { }

	close () {
		this.onClose.emit();
	}
}
